module.exports = __webpack_public_path__ + "static/media/CUBIERTA ARCOSOPORTANTE CON TRASLUCIDAS.771be059.jpg";